var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.75C5.124 0.75 0.75 5.124 0.75 10.5C0.75 15.876 5.124 20.25 10.5 20.25C15.876 20.25 20.25 15.876 20.25 10.5C20.25 5.124 15.876 0.75 10.5 0.75ZM10.5 2.25C15.0653 2.25 18.75 5.93475 18.75 10.5C18.75 15.0653 15.0653 18.75 10.5 18.75C5.93475 18.75 2.25 15.0653 2.25 10.5C2.25 5.93475 5.93475 2.25 10.5 2.25ZM9.75 6V9.75H6V11.25H9.75V15H11.25V11.25H15V9.75H11.25V6H9.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.b1af2b1a0a605a7841136e03ddaf9ba4.svg";
export { ForwardRef as ReactComponent };